import React from 'react';

export default function DocCards({ doc }) {
  return (
    <div className='flex items-center justify-start gap-3 flex-wrap rounded-md border bg-gray-50 dark-bg p-3'>
      {doc?.map((docItem) => {
        const fileName = docItem.documentURL.split('/').pop();

        console.log(fileName)

        return (
          <div key={docItem.documentID}>
            <a href={docItem.documentURL} target="_blank" rel="noopener noreferrer">
              {fileName}
            </a>
          </div>
        );
      })}
    </div>
  );
}
